import { Component, Link, withState, withProps } from "@mna/react";
import kebabCase from "@mna/utils/kebabCase";
import CareOptionsTitle from "pages/find-care-options/care-options/Title";
import CareOptionsView from "pages/find-care-options/care-options/View";
import LoadingScreen from "features/LoadingScreen";
import { Trans } from "react-i18next";
import Modal from 'react-modal';
import {checkAndGetSessionStorageValue,checkAndGetLocalStorageValue} from "../../../features/utils";
import {careOptions} from "../../../server/triage/constants"
import i18next from "../../../../src/i18n"
import { updateTriageLogCoordination } from "../../../state/triage/actions/questions";


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
  }
};

const careOptionsWithoutLocations = [
  "telemedicine",
  "concierge-care",
  "house-visit",
];

var filteredCareOptions = []

const CareOptions = ({
  state,
  setState,
  actions,
  history,
  store,
  previousStepName,
  nextStepName,
  cards,
  numberOfCards,
  viewMode,
  toggleViewMode,
  selectCareOption,
  goCareOption,
  selectDeclineCareOption,
  careOptionsFilter,
  updateCoordination
}) => (
  <div className="my-3 mx-2 text-center">
    <LoadingScreen isLoading={state.isLoading}>
      <CareOptionsTitle {...{ toggleViewMode, viewMode, numberOfCards }} />

      {numberOfCards > 0 ? (
        <>
          <CareOptionsView
            {...{
              state,
              setState,
              history,
              cards,
              numberOfCards,
              viewMode,
              goCareOption,
              selectCareOption,
              selectDeclineCareOption,
              updateCoordination
            }}
            onChange={selectCareOption}
          />
          {viewMode !== "carousel" ? null : (
            <div className="mx-auto hideSelectButton " style={{ maxWidth: "300px" }}>
              <button
                type="button"
                className="button standby-button standby-button-gradient standby-button-gradient-green w-100"
                onClick={() => {                  
                  if(checkAndGetSessionStorageValue("IsValidUser") === "true"){
                    if(state.triageRequest.selectedCareOptionName === careOptions.HouseVisit || state.triageRequest.selectedCareOptionName === careOptions.ConciergeCare){
                      careOptionsFilter(cards);
                      var alt = filteredCareOptions[0].alt
                      var value = filteredCareOptions[0].value                      
                      goCareOption({alt,value});                      
                      gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                    }
                    else {
                      goCareOption();                      
                      gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                    }
                    
                  }                  
                  else {
                    goCareOption();                    
                    gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                  }  
                }
                }
              >
                <Trans i18nKey="findcareoption.Careoptions.select">
                  Select
                </Trans>
              
              </button>
              <div style={{
                justifyContent: "center",
                alignItems:"center",
                display: "flex",
                paddingTop:"20px",
                paddingBottom: "15px"
                }}>
        
                <a className="view-mode-toggle"
                  onClick={e=>{
                    localStorage.setItem("careoption","")
                          setState({
                            showModal1: true
                          })
                  }}
                  onKeyDown={(e)=>{
                    if(e.key === " "|| e.key === "Spacebar"){
                      localStorage.setItem("careoption","")
                          setState({
                            showModal1: true
                          })
                    }
                  }}
                  href='#'
                  >
                  {<Trans i18nKey="findcareoption.Careoptions.Decline_care">Decline Care</Trans>}
                </a>
              </div>
            </div> 
          )}

          {viewMode !== "list" ? null : (
            <div className="mx-auto standby-info-card-view standby-info-card-view-mobile showSelectButton" style={{ maxWidth: "300px" }}>
              <button
                type="button"
                className="button standby-button standby-button-gradient standby-button-gradient-green w-100"
                onClick={() => {                  
                  if(checkAndGetSessionStorageValue("IsValidUser") === "true"){
                    if(state.triageRequest.selectedCareOptionName === careOptions.HouseVisit || state.triageRequest.selectedCareOptionName === careOptions.ConciergeCare){
                      careOptionsFilter(cards);
                      var alt = filteredCareOptions[0].alt
                      var value = filteredCareOptions[0].value                      
                      goCareOption({alt,value});
                    }
                    else {
                      goCareOption();
                    }
                    
                  }                  
                  else {
                    goCareOption();
                  }  
                }
                }
              >
                <Trans i18nKey="findcareoption.Careoptions.select">
                  Select
                </Trans>
              
              </button>
              <div style={{
                justifyContent: "center",
                alignItems:"center",
                display: "flex",
                paddingTop:"20px",
                paddingBottom: "15px"
                }}>
        
                <a className="view-mode-toggle"
                  onClick={e=>{
                    localStorage.setItem("careoption","")
                          setState({
                            showModal1: true
                          })
                  }}
                  href='#'
                  onKeyDown={(e)=>{
                    if(e.key === " "|| e.key === "Spacebar"){
                      localStorage.setItem("careoption","")
                          setState({
                            showModal1: true
                          })
                    }
                  }}
                  >
                  {<Trans i18nKey="findcareoption.Careoptions.Decline_care">Decline Care</Trans>}
                </a>
              </div>
            </div>

            
            
          )}
        </>
      ) : (
        <>
          <p className="color-dark-gray">
          {<Trans i18nKey="findcareoption.Careoptions.norecommendedcareoptions">No recommended care options were found.</Trans>}
          </p>
          <div className="content-width mt-3">
            <Link to={`/find-care-options/${previousStepName}`}>
              <button
                type="button"
                className="button standby-button standby-button-gradient standby-button-gradient-green"
              >
                {<Trans i18nKey="findcareoption.Careoptions.goback">Go Back</Trans>}
              </button>
            </Link>
          </div>
        </>
      )}
    </LoadingScreen>
    {!state.showModal &&( <Modal 
         isOpen={state.showModal1}
         contentLabel="customStyles"
         className="ReactModal__Content_triagepopup" overlayClassName="ReactModal__Overlay_triagepopup"
         role=""
        >
         <label className="confirm_title">
          {<Trans i18nKey="findcareoption.Careoptions.Please_confirm">Please confirm</Trans>}    
          </label>
          <label>
          {<Trans i18nKey="findcareoption.Careoptions.Confirm_care">Are you sure you wish to decline your suggested care options and cancel the triage</Trans>}    
          </label>
          <div className="pop_button">
            <button className="modal_yes"
              aria-label= {i18next.t("findcareoption.Careoptions.Confirm_care")+ " " +i18next.t("findcareoption.Yes")}
              onClick={e=>{
                  setState({
                      showModal1: false
                  });
                state.triageRequest.selectedCareOptionName = careOptions.DeclineCare;
                localStorage.setItem('careoption', careOptions.DeclineCare);
                updateCoordination();
                selectDeclineCareOption();
                history.push({
                  pathname: "/find-care-options/thank-you",
                  search: "?decline=1",
                });

              }}>
              <Trans i18nKey="findcareoption.Yes">Yes</Trans>
            </button>
            <button className="modal_no"
            aria-label={i18next.t("findcareoption.Careoptions.Confirm_care") + " " + i18next.t("findcareoption.No")}
              onClick={e=>{
                  setState({
                      showModal1: false
                })
              }}>
              <Trans i18nKey="findcareoption.No">No</Trans>
            </button>
          </div>
    </Modal> )  }   
  </div>
);
export default withState({
  state: {
    viewMode: "carousel"
  },
  actions: {    
    toggleViewMode: ({ store }) =>
      store.setState({
        viewMode: store.state.viewMode === "carousel" ? "list" : "carousel",
      }),

    careOptionsFilter: (cards) => {
      var cardsArray = cards.props
      cardsArray.filter(card => card.alt !== careOptions.HouseVisit && card.alt !==careOptions.ConciergeCare).forEach(element => {
        filteredCareOptions.push(element)
        } )
    },
    
    selectCareOption: ({ alt, value, store }) => {
      const { actions } = store.props;
      actions.setTriageSelectedCareOption({ name: alt, score: value });
    },
    selectDeclineCareOption: ({ store }) => {
      const { actions, history, state } = store.props;
      actions.setTriageDeclineCareOption({ actions, history, state });
    },
    updateCoordination: ({store}) =>{
      const {actions, state} = store.props;
      var data = updateTriageLogCoordination(state);
      console.log(data)
      actions.sendTriageRequest({ action: 'UpdateTriageCoordination', data })
     // actions.UpdateTriageCoordination({data});
    },
    goCareOption: ({ store, alt, value  }) => {      
      const { actions, history, state } = store.props;
      if (alt && value) {
        actions.setTriageSelectedCareOption({ name: alt, score: value });
      }      
      const { name = "" } = actions.getTriageSelectedCareOption();
      let slug;
      let tempCareOption;
      if (alt != undefined) {
        actions.setTriageSelectedCareOption({ name: alt, score: value });
        slug = kebabCase(alt);
        tempCareOption=alt;
      } else {
        tempCareOption=name;
        slug = kebabCase(name);
      }
      localStorage.setItem('careoption', tempCareOption)
      const resultStep = careOptionsWithoutLocations.includes(slug)
        ? slug
        : "care-options-result";

      state.triageResponse.selectedConnectionType="";

      if (resultStep === "telemedicine") {
        var vendorArrayList = state.triageResponse.vendorsList;
        var vendorsLength = 0;
        if(vendorArrayList){
          vendorsLength = vendorArrayList.length;
        }
        
        if (vendorsLength === 0) {
          history.push(`/find-care-options/telemedicine-info`);
        } else if (vendorsLength >= 1) {
          var vendorSupportedModal =
            vendorArrayList[0].accessInformation.virtualAccessInformation
              .webAccessReferences[0].supportedModalities;
              state.triageRequest.supportedModalities = vendorSupportedModal.length
          if (vendorSupportedModal.length >= 2) {
            //both option
            history.push(`/find-care-options/telemed-connectiontype`);
          } else {
            if (vendorSupportedModal[0] === "Video") {
              //redirect to video prompt
              state.triageResponse.selectedConnectionType="2"
              history.push(`/find-care-options/telemed-videoprompt`);
            } else {
              //redirect to connection page
              state.triageResponse.selectedConnectionType="1"
              history.push(`/find-care-options/telemedicine-info`);
            }
          }
        } else if (vendorsLength > 1) {
          var allVendorsArray = [];
          state.triageResponse.vendorsList.map((item) => {
            var vendors = item.nameLocalization.localizations[0].value;
            if (allVendorsArray.indexOf(vendors) === -1) {
              allVendorsArray.push(vendors);
            }
          });
          if (allVendorsArray.length >= 1) {
            var vendorSupportedModalities =
              vendorArrayList[0].accessInformation.virtualAccessInformation
                .webAccessReferences[0].supportedModalities;
           
            if (vendorSupportedModalities.length >= 2) {
              //both option
              history.push(`/find-care-options/telemed-connectiontype`);
            } else {
              if (vendorSupportedModalities[0] === "Video") {
                state.triageResponse.selectedConnectionType="2"
                //redirect to video prompt
                history.push(`/find-care-options/telemed-videoprompt`);
              } else {
                state.triageResponse.selectedConnectionType="1"
                //redirect to connection page
                history.push(`/find-care-options/telemedicine-info`);
              }
            }
          } else {
            history.push(`/find-care-options/telemedicine-info`);
          }
        }
      } else {
        history.push(`/find-care-options/${resultStep}`);
      }
    },
  },

  willMount({ actions }) {
    console.log("will Mount FTW");
  },

  didMount({ actions, state }) {
    console.log("did Mount FTW");
    actions.clearTriageSelectedCareOption();
    state.triageRequest.activeMenu = "care-options"
  },

  withProps: ({
    store: {
      state: { viewMode },
      actions: { toggleViewMode, selectCareOption, goCareOption,  selectDeclineCareOption,careOptionsFilter, updateCoordination},
    },
    state: {
      triageResponse: { recommendedCareOptions = [] },
    },
  }) => ({
    cards: recommendedCareOptions,
    numberOfCards: recommendedCareOptions.length,
    viewMode,
    toggleViewMode,
    selectCareOption,
    goCareOption,
    selectDeclineCareOption,
    careOptionsFilter,
    updateCoordination
  }),
})(CareOptions);
